module.exports = __webpack_public_path__ + "static/media/integral_card_3.5434353e.png";